import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { JwtService } from '@okcargo-apps/shared-infrastructure';
import { catchError, from, map, of, switchMap, take } from 'rxjs';

export const loginGuard: CanActivateFn = (route, state) => {
  const accountService = inject(AccountService);
  const jwtService = inject(JwtService);
  const router = inject(Router);

  return jwtService.userDataReceived$.pipe(
    take(1),
    switchMap((userDataReceived) => {
      if (userDataReceived) {
        return accountService.hasCapability$(ECapabilities.AUTHENTICATED).pipe(
          map((hasCap) => {
            if (hasCap) {
              router.navigate(['/tabs/dashboard']);
              return false;
            }
            return true;
          }),
        );
      } else {
        const accessToken = jwtService.accessToken;
        const refreshToken = jwtService.refreshToken;
        if (accessToken && refreshToken) {
          return from(accountService.checkUserAuthentication()).pipe(
            switchMap(() => accountService.hasCapability$(ECapabilities.AUTHENTICATED)),
            map((hasCap) => {
              if (hasCap) {
                router.navigate(['/tabs/dashboard']);
                return false;
              }
              return true;
            }),
            catchError(() => of(true)),
          );
        } else {
          return of(true);
        }
      }
    }),
  );
};
